import React from "react";
import GalleryScreen from "./components/gallery/GalleryScreen";
import ConversationsScreen from "./components/conversations/ConversationsScreen";
import ChatScreen from "./components/chat/ChatScreen";
import { createHistory, LocationProvider, Router } from '@reach/router'
import createHashSource from 'hash-source'
import { CSSTransition, TransitionGroup } from "react-transition-group";

const FadeTransitionRouter = props => {
  let source = createHashSource();
  let history = createHistory(source);

  return <LocationProvider history={history}>
    {({ location }) => (
      <TransitionGroup className="container">
        <CSSTransition key={location.pathname} classNames={"slide"} timeout={500}>
          <Router location={location} className="container">
            {props.children}
          </Router>
        </CSSTransition>
      </TransitionGroup>
    )}
  </LocationProvider>
};

export default () => {

  return <FadeTransitionRouter>
    <ChatScreen path={"/chat/:storyName"}/>
    <GalleryScreen path={"/gallery/:storyName"}/>
    <ConversationsScreen path="/"/>
  </FadeTransitionRouter>
}
